export const storeHours = [
    { days: 'Mon-Thu', hours: '9 AM - 6 PM' },
    { days: 'Fri-Sat', hours: '8 AM - 5 PM' },
    { days: 'Sun', hours: 'Closed' },
];

export function buildDailyHoursMap(config) {
    const map = {};

    config.forEach(({ days, hours }) => {
        const dayParts = days.split(',').flatMap((part) => expandDays(part.trim()));
        const isClosed = hours.toLowerCase() === 'closed';
        dayParts.forEach((dayIndex) => {
            if (isClosed) {
                map[dayIndex] = null;
            } else {
                const [open, close] = hours.split(' - ');
                map[dayIndex] = { open, close };
            }
        });
    });

    return map;
}

export function expandDays(range) {
    const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

    if (range.includes('-')) {
        const [start, end] = range.split('-');
        const startIdx = dayMap[start];
        const endIdx = dayMap[end];
        if (startIdx <= endIdx) return Array.from({ length: endIdx - startIdx + 1 }, (_, i) => startIdx + i);
        return [
            ...Array.from({ length: 7 - startIdx }, (_, i) => startIdx + i),
            ...Array.from({ length: endIdx + 1 }, (_, i) => i),
        ];
    }
    return [dayMap[range]];
}

export function to24HourTime(timeStr) {
    // 1) Trim off any surrounding whitespace
    let str = timeStr.trim();

    // 2) Separate out an AM/PM suffix if present
    let ampm = '';
    const parts = str.split(' ');
    if (parts.length === 2) {
        [str, ampm] = [parts[0], parts[1].toUpperCase()];
    }

    // 3) Split hours and minutes (if no ":", minutes = 0)
    const [hourPart, minutePart] = str.split(':');
    let hour = parseInt(hourPart, 10);
    const minute = minutePart ? parseInt(minutePart, 10) : 0;

    // 4) Adjust for AM/PM
    if (ampm === 'AM' && hour === 12) {
        hour = 0; // 12 AM → 0:00
    } else if (ampm === 'PM' && hour < 12) {
        hour += 12; // 1 PM→13, … 11 PM→23
    }

    return [hour, minute];
}
